import React, { lazy } from 'react';
import ProtectedRoute from '@/router/components/ProtectedRoute';
import { ROUTES } from '@/constants/routes';

// Lazy loaded components
const ReleaseAnalyzerAgentPage = lazy(
  () => import('@/pages/agents/release-analyzer'),
);
const FileCompareAgentPage = lazy(() => import('@/pages/agents/file-compare'));
const KnowledgeBasePage = lazy(() => import('@/pages/agents/knowledge-base'));
const ReleaseTestCaseCreatorAgentPage = lazy(
  () => import('@/pages/agents/release-test-case-creator'),
);

/**
 * Agent-related routes configuration
 */
export const agentRoutes = [
  {
    path: ROUTES.RELEASE_ANALYZER,
    element: <ProtectedRoute component={ReleaseAnalyzerAgentPage} />,
  },
  {
    path: ROUTES.FILE_COMPARE,
    element: <ProtectedRoute component={FileCompareAgentPage} />,
  },
  {
    path: ROUTES.KNOWLEDGE_BASE,
    element: <ProtectedRoute component={KnowledgeBasePage} />,
  },
  {
    path: ROUTES.TEST_CASE_CREATOR,
    element: <ProtectedRoute component={ReleaseTestCaseCreatorAgentPage} />,
  },
];
